import { all, call, delay, fork, put, takeLeading } from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import * as requests from 'src/common/helpers/HTTPRequest';
import { toastError, toastSuccess } from 'src/common/helpers/Notifications';
import TextConstants from 'src/common/helpers/TextConstants';
import {
  activateUserCleanState,
  activateUserError,
  activateUserSuccess,
  registeredActions,
} from './actions';

function* activateUser({ payload }) {
  try {
    const requestBody = { ...payload };
    const url = `${ApiConstants.BASE_URL}${ApiConstants.ACTIVE_USERS}`;
    const apiRes = yield call(requests.postRequest, url, requestBody, false);
    if (apiRes) {
      toastSuccess(apiRes?.message || TextConstants.Common.Success);
      yield put(activateUserSuccess());
    } else {
      toastError('Oops! something went wrong!');
      yield put(activateUserError({ message: 'Oops! something went wrong!' }));
    }
  } catch (error) {
    console.log(error);
    toastError(error?.message);
    yield put(activateUserError({ message: error?.message || '' }));
  } finally {
    yield delay(500);
    yield put(activateUserCleanState());
  }
}

export function* watchActivateUser() {
  yield takeLeading(registeredActions.ACTIVATE_USER, activateUser);
}

export default function* rootSaga() {
  yield all([fork(watchActivateUser)]);
}
